(() => {
  function mount(scope = document) {
    scope.querySelectorAll('[data-pearl-product]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const data = JSON.parse(root.querySelector('[data-pearl-data]').textContent);
      const fr = document.documentElement.lang.startsWith('fr');
      const type = root.querySelector('#pearl-type');
      const size = root.querySelector('#pearl-size');
      const metals = [...root.querySelectorAll('[name="pearl-metal"]')];
      const chosenMetal = () => metals.find(input => input.checked).value;
      const metalLabel = () => chosenMetal() === 'white' ? (fr ? 'Or blanc' : 'White gold') : (fr ? 'Or jaune' : 'Yellow gold');
      const photo = root.querySelector('#mgp-image');
      const zoomImage = root.querySelector('#mgp-zoom-image');
      const dialog = root.querySelector('#mgp-zoom');
      const form = root.querySelector('[data-pearl-form]');
      const variant = root.querySelector('[data-pearl-variant]');
      const buy = root.querySelector('[data-pearl-buy]');
      const enquiry = root.querySelector('[data-pearl-enquire]');
      const status = root.querySelector('[data-pearl-status]');
      const pending = fr ? 'À confirmer avec MAGDOR' : 'To confirm with MAGDOR';
      const format = value => new Intl.NumberFormat(fr ? 'fr-CA' : 'en-CA', {style:'currency',currency:data.currency || 'CAD'}).format(value / 100);
      function selected() { return data.items.find(item => item.type === type.value && item.size === size.value); }
      function update() {
        const item = selected();
        const needsConfirmation = item?.size === 'pending' || item?.type === 'pending';
        const metalMatches = !!item && chosenMetal() === item.metal;
        const available = !!item && item.available && Number(item.price) > 0 && !needsConfirmation && metalMatches;
        const src = item?.images?.[chosenMetal()] || (chosenMetal() === 'white' ? data.mainWhiteImage : data.mainImage);
        photo.removeAttribute('srcset');
        photo.src = src;
        zoomImage.src = src;
        const typeLabel = type.selectedOptions[0]?.textContent || '';
        photo.alt = data.title + ' — ' + metalLabel() + (item && !needsConfirmation ? ', ' + typeLabel + ', ' + item.size + ' mm' : '');
        zoomImage.alt = photo.alt;
        root.querySelector('[data-pearl-price]').textContent = format(item?.price ?? data.mainPrice);
        root.querySelector('[data-pearl-stone]').textContent = item ? (needsConfirmation ? (fr ? 'Perle — type à confirmer' : 'Pearl — type to confirm') : typeLabel) : (fr ? 'Perle' : 'Pearl');
        root.querySelector('[data-pearl-metal]').textContent = metalLabel();
        root.querySelector('[data-pearl-measurement]').textContent = item ? (item.size === 'pending' ? pending : item.size + ' mm') : (fr ? 'À sélectionner' : 'Select an option');
        variant.value = available ? item.variantId : '';
        variant.disabled = !available;
        buy.disabled = !available;
        buy.hidden = !!item && !available;
        enquiry.hidden = !item || available;
        const params = new URLSearchParams({product:data.title,metal:metalLabel(),configuration:metalLabel() + ' / ' + typeLabel + ' / ' + (size.selectedOptions[0]?.textContent || '')});
        enquiry.href = data.contact + '?' + params.toString();
        status.textContent = !item ? (fr ? 'Choisissez le type et la taille des perles.' : 'Choose your pearl type and size.') : needsConfirmation ? (fr ? 'Contactez-nous pour confirmer le type et la taille des perles de cette paire.' : 'Contact us to confirm the pearl type and size of this pair.') : available ? (item.backorder ? data.messages.availableToOrder : data.messages.inStock) : (fr ? 'Sur demande — contactez-nous pour confirmer la disponibilité de cette configuration.' : 'Upon request — contact us to confirm availability of this configuration.');
      }
      function updateSizes() {
        size.replaceChildren(new Option(fr ? 'Choisissez la taille' : 'Choose the size', ''));
        const matching = data.items.filter(item => item.type === type.value);
        matching.forEach(item => size.add(new Option(item.size === 'pending' ? pending : item.size + ' mm', item.size)));
        size.disabled = matching.length === 0;
        update();
      }
      metals.forEach(input => input.addEventListener('change', update));
      type.addEventListener('change', updateSizes);
      size.addEventListener('change', update);
      form.addEventListener('submit', event => {
        if (!variant.value || buy.disabled) { event.preventDefault(); return; }
        type.name = 'properties[' + (fr ? 'Type de perles' : 'Pearl type') + ']';
        size.name = 'properties[' + (fr ? 'Taille des perles' : 'Pearl size') + ']';
        root.querySelectorAll('[data-pearl-property]').forEach(input => input.remove());
        for (const [name, value] of [[type.name,type.selectedOptions[0].textContent],[size.name,size.selectedOptions[0].textContent],['properties[' + (fr ? 'Métal' : 'Metal') + ']',metalLabel()]]) {
          const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value; input.dataset.pearlProperty = ''; form.append(input);
        }
        type.removeAttribute('name'); size.removeAttribute('name');
        metals.forEach(input => input.removeAttribute('name'));
      });
      let returnFocus, overflow;
      function open(event) { returnFocus = event.currentTarget; overflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; dialog.showModal(); dialog.querySelector('button').focus(); }
      root.querySelector('[data-pearl-zoom]').addEventListener('click', open);
      photo.tabIndex = 0; photo.setAttribute('role','button'); photo.setAttribute('aria-label',fr ? 'Agrandir la photo du produit' : 'Enlarge product photo');
      photo.addEventListener('click', open);
      photo.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(event); } });
      root.querySelector('[data-pearl-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { document.documentElement.style.overflow = overflow; returnFocus?.focus(); });
      updateSizes();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount()); else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();

